import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  ListSearchCampaign: (token, adsId, startDate, endDate, orderBy, orderType, start, limit) =>
    createAction(constants.LIST_SEARCH_CAMPAIGN, {
      token,
      adsId,
      startDate,
      endDate,
      orderBy,
      orderType,
      start,
      limit,
    }),
  ListTopKeyword: (token, adsId, startDate, endDate, orderBy, orderType) =>
    createAction(constants.LIST_TOP_KEYWORD, { token, adsId, startDate, endDate, orderBy, orderType }),
  ListDisplayCampaign: (token, adAccountId, startDate, endDate, orderBy, start, limit) =>
    createAction(constants.LIST_DISPLAY_CAMPAIGN, { token, adAccountId, startDate, endDate, orderBy, start, limit }),
  ListTopAudience: (token, adAccountId, startDate, endDate, orderBy, start, limit) =>
    createAction(constants.LIST_TOP_AUDIENCE, { token, adAccountId, startDate, endDate, orderBy, start, limit }),
  ListTopPlacement: (token, adAccountId, startDate, endDate, orderBy, start, limit) =>
    createAction(constants.LIST_TOP_PLACEMENT, { token, adAccountId, startDate, endDate, orderBy, start, limit }),
};

export default actions;
